import React from "react";
import { TColor } from "../../types";

export type TBadgeVariant = "default" | "secondary" | "tertiary" | "success" | "error";

export interface IColorProps {
    iconColor: TColor | string;
    bgColor: TColor | string;
    color: TColor | string;
}

export interface IVariant extends Record<keyof IColorProps, TColor> {
    icon?: React.ReactNode;
}

export type TBadgeProps = React.ComponentPropsWithoutRef<"div"> &
    Partial<IColorProps> & {
        variant?: TBadgeVariant;
        text: React.ReactNode;
        icon?: boolean | React.ReactNode;
        iconPosition?: "before" | "after";
    };
